import './App.css';
import React, { useState,useEffect } from 'react';
import { JsonView, allExpanded, defaultStyles } from 'react-json-view-lite';
import 'react-json-view-lite/dist/index.css';
import Header from './components/Header';
import {
    TextField,
    Select,
    MenuItem,
    Button,
    FormControl,
    FormControlLabel,
    InputLabel,
    Switch,
    Box,
    Typography,
    Container
} from '@mui/material';
import useAppStyles from './styles/appStyles';

function App() {
    const classes = useAppStyles();
    const [data, setData] = useState(null);
    const [searchTerm, setSearchTerm] = useState("");
    const [secondSearchTerm, setSecondSearchTerm] = useState("");
    const [expandAll, setExpandAll] = useState(false);

    const [accountFilter, setAccountFilter] = useState("None"); // State to store the input value

    const [searchType, setSearchType] = useState("account"); // State to store the selected search type
    const [promotionCount, setPromotionCount] = useState(null); // State to store the number of promotions
    const [advancedMode, setAdvancedMode] = useState(false);


    useEffect(() => {
        const hash = window.location.hash.replace(/^#/, "");
        const params = new URLSearchParams(hash);
        const type = params.get("type") || "account";
        const term = params.get("term") || "";
        const filter = params.get("filter") || "None";
        const second = params.get("second") || "";

        setSearchType(type);
        setSearchTerm(term);
        setAccountFilter(filter);
        setSecondSearchTerm(second);

        if (term) {
            callApi(type, term, filter, second);
        }
    }, []);

    function handleSearch() {
        const params = new URLSearchParams();
        params.set("type", searchType);
        params.set("term", searchTerm);
        if (searchType === "account") {
            params.set("filter", accountFilter);

        }
        if(secondSearchTerm) {
            params.set("second", secondSearchTerm);
        }
        window.location.hash = params.toString();
        callApi(searchType, searchTerm, accountFilter, secondSearchTerm);
    }


    function callApi(searchType, searchTerm, accountFilter , secondSearchTerm) {
        if (!searchTerm) {
            console.log("Please enter a promo ID or account ID.");
            return;
        }
        let endpoint = "";
        switch (searchType){
            case "id":
                endpoint = `/api/promotions/${searchTerm}`;
                break;
            case "account":
                if(accountFilter === "None") {
                    endpoint = `/api/promotions?accountId=${searchTerm}`;
                    break;
                }
                if(accountFilter === "createdBy") {
                    endpoint = `/api/promotions/accountId/${searchTerm}/createdBy/${secondSearchTerm}`;
                    break;
                }
                if(accountFilter === "assetId") {
                    endpoint = `/api/promotions/accountId/${searchTerm}/assetId/${secondSearchTerm}`;
                    break;
                }
                break;

            case "asset":
                endpoint = `/api/promotions/assetId/${searchTerm}`;
                break;
            case "createdBy":
                endpoint = `/api/promotions/createdBy/${searchTerm}`;
                break;
            default:
                console.log("Invalid search type");
                return;
        }

        fetch(endpoint)
            .then(response => response.json())
            .then(result => {
                if (searchType === "account" && accountFilter !== "None") {
                    const promos = result;
                    console.log(result);
                    setData(promos);
                    const count = promos.length;
                    console.log(`Number of promotions found: ${count}`);
                    setPromotionCount(count); // Update state with the count
                }

                else if (searchType === "account" && Array.isArray(result._embedded.promotions)) {
                    const promos = result._embedded.promotions;
                    console.log(result);
                    setData(promos);
                    const count = promos.length;
                    console.log(`Number of promotions found: ${count}`);
                    setPromotionCount(count); // Update state with the count
                }
                else if (searchType !== "account" && Array.isArray(result)) {
                    const promos = result;
                    console.log(result);
                    setData(promos);
                    const count = promos.length;
                    console.log(`Number of promotions found: ${count}`);
                    setPromotionCount(count); // Update state with the count
                }

                else if (searchType === "id") {
                    console.log(result);
                    setData(result);
                    setPromotionCount(null); // Reset count for ID search
                }
            })
            .catch(error => console.log('error', error));
    }

    function handleDelete() {
        if (!searchTerm) return;
        fetch(`/api/promotions/${searchTerm}`, { method: 'DELETE' })
            .then(response => {
                if (response.ok) {
                    setData(null);
                    setPromotionCount(null);
                } else {
                    console.log('Delete failed', response.status);
                }
            })
            .catch(error => console.log('error', error));
    }

    return (
        <div className={classes.appContainer}>
            <Header />
            <div className={classes.contentWrapper}>
                <Container
                    maxWidth={false}
                    sx={{
                        margin: 0,
                        padding: 0,
                        maxWidth: 'none',
                        '&.MuiContainer-root': {
                            paddingLeft: 0,
                            paddingRight: 0,
                            marginLeft: 0,
                            marginRight: 0,
                        }
                    }}
                >
                    <Box className={classes.formContainer}>
                        <Box className={classes.formRow}>
                            <FormControl className={classes.formControl}>
                                <InputLabel>Search by</InputLabel>
                                <Select
                                value={searchType}
                                onChange={(e) => {
                                    setSearchType(e.target.value);
                                    setSearchTerm("");
                                    setPromotionCount(null);
                                }}
                            >
                                <MenuItem value="account">Account</MenuItem>
                                <MenuItem value="id">Promo Id</MenuItem>
                                <MenuItem value="asset">Asset Id</MenuItem>
                                <MenuItem value="createdBy">Created By</MenuItem>
                            </Select>
                        </FormControl>

                        <TextField
                            className={classes.textField}
                            label="Enter Search Term"
                            variant="outlined"
                            value={searchTerm}
                            onKeyDown={(e) => { if (e.key === "Enter") handleSearch(); }}
                            onChange={(e) => setSearchTerm(e.target.value)}
                        />

                        {searchType === "account" && (
                            <>
                                <FormControl className={classes.formControl}>
                                    <InputLabel>Filter by</InputLabel>
                                    <Select
                                        value={accountFilter}
                                        onChange={(e) => {
                                            setAccountFilter(e.target.value);
                                            setSecondSearchTerm("");
                                        }}
                                    >
                                        <MenuItem value="None">None</MenuItem>
                                        <MenuItem value="createdBy">Created By</MenuItem>
                                        <MenuItem value="assetId">Asset Id</MenuItem>
                                    </Select>
                                </FormControl>

                                {accountFilter !== "None" && (
                                    <TextField
                                        className={classes.textField}
                                        label="Enter Filter Value"
                                        variant="outlined"
                                        value={secondSearchTerm}
                                        onKeyDown={(e) => { if (e.key === "Enter") handleSearch(); }}
                                        onChange={(e) => setSecondSearchTerm(e.target.value)}
                                    />
                                )}
                            </>
                        )}

                        <Button
                            variant="contained"
                            color="primary"
                            className={classes.button}
                            onClick={handleSearch}
                        >
                            Search
                        </Button>

                        {searchType === "id" && (
                            <FormControlLabel
                                control={
                                    <Switch
                                        checked={advancedMode}
                                        onChange={(e) => setAdvancedMode(e.target.checked)}
                                    />
                                }
                                label="Advanced"
                                sx={{ marginBottom: 1, marginLeft: 1 }}
                            />
                        )}
                    </Box>

                    {advancedMode && searchType === "id" && data && (
                        <Box sx={{ marginBottom: 2 }}>
                            <Button
                                variant="contained"
                                color="error"
                                className={classes.deleteButton}
                                onClick={handleDelete}
                            >
                                Delete Promotion
                            </Button>
                        </Box>
                    )}

                    {promotionCount !== null && (
                        <Box className={classes.promotionCount}>
                            <Typography variant="h6">
                                Number of promotions found: {promotionCount}
                            </Typography>
                        </Box>
                    )}

                    {searchType === "id" && data && (
                        <Box className={classes.jsonContainer}>
                            <div style={{ display: "flex", gap: "20px" }}>
                                <div style={{ flex: 1 }}>
                                    <h3>Full JSON</h3>
                                    <JsonView data={data} shouldExpandNode={allExpanded} style={defaultStyles} />
                                </div>
                                <div style={{ flex: 1 }}>
                                    <h3>i18n Data</h3>
                                    <JsonView data={data.i18n} shouldExpandNode={allExpanded} style={defaultStyles} />
                                </div>
                                <div style={{ flex: 1 }}>
                                    <h3>placement Data</h3>
                                    <JsonView data={data.placement} shouldExpandNode={(level) => level <= 2} style={defaultStyles} />
                                </div>
                            </div>
                        </Box>
                    )}

                    {searchType !== "id" && data && (
                        <Box className={classes.jsonContainer}>
                            <Button
                                variant="contained"
                                color="secondary"
                                className={classes.toggleButton}
                                onClick={() => setExpandAll(!expandAll)}
                            >
                                {expandAll ? 'Collapse All' : 'Expand All'}
                            </Button>
                            {expandAll && (
                                <JsonView data={data} style={defaultStyles} />
                            )}
                            {!expandAll && (
                                <JsonView data={data} shouldExpandNode={(level) => level <= 1} style={defaultStyles} />
                            )}
                        </Box>
                    )}
                </Box>
            </Container>
            </div>
        </div>
    );
}

export default App;
